import { Injectable } from '@angular/core';
import {
	ActivatedRouteSnapshot,
	CanActivate,
	RouterStateSnapshot,
} from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable()
export class AuthGuard implements CanActivate {
	private static navigateToFO() {
		window.location.href = environment.foURL;
	}

	canActivate(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): Observable<boolean> | Promise<boolean> | boolean {
		const token = localStorage.getItem('EMRAdmin.accessToken');

		if (!token) {
			AuthGuard.navigateToFO();
		}

		return true;
	}
}
